import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=521589ed&scoped=true"
import script from "./Index.vue?vue&type=script&setup=true&lang=js"
export * from "./Index.vue?vue&type=script&setup=true&lang=js"
import style1 from "./Index.vue?vue&type=style&index=1&id=521589ed&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "521589ed",
  null
  
)

export default component.exports